import React, { JSX } from 'react';

import { useStyles } from './cards-list.styles';
import { CardsListProps } from './cards-list.models';
import { Card } from '../../card';

export const CardsList = ({ cards }: CardsListProps): JSX.Element => {
  const classes = useStyles();

  return (
    <ul
      className={classes.root}
      data-testid="cards-list"
    >
      {
        cards?.map((card) => (
          <li
            key={card.title}
            className={classes.listItem}
          >
            <Card icon={card.icon} title={card.title} content={card.content} />
          </li>
        ))
      }
    </ul>
  );
};
